import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fec01c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Status", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "FileName", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Fit", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["colspan"]
const _hoisted_7 = { key: 0 }

import {ref, inject, computed, watch, Ref} from "vue";
    import {key} from "@/components/FileManager";
    import { circuitConfigInjectionKey, defaultCircuits } from "./CircuitSelector/CircuitManager";
    import { extractParams } from "./CircuitSelector/CircuitAnalyzer";
    import Spinner from "./Parts/MiniSpinner.vue";
import MiniCheckMark from "./Parts/MiniCheckMark.vue";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ParameterTable',
  setup(__props) {

    const fs = ref(inject(key));
    const circuitconfig = ref(inject(circuitConfigInjectionKey, defaultCircuits));
    

    //result to store
    const results = computed(()=> fs?.value?.keys().map((key)=>{

        const record = fs?.value?.files[key];
        if(!record || !record.fitting_result.isDone){
            return {
                id: key,
                name: record?.file.name,
                params: [] as [string,string][]
            };
        }
        let output = {
            id: key,
            name: record.file.name,
            params: [] as [string, string][]
        };

        const fitting_params = record.fitting_result.params;
        if(!fitting_params){
            return output;
        }

        const kvs = Object.entries(fitting_params);
        if(!kvs){
            return output;
        }
        output.params = params.value.map(name=>{
            const kv = kvs.find(kv=>kv[0]===name);
            if(!kv){
                //throw new Error("Fitting Parameter Not Found Error");
                return undefined;
            }
        });
        return output;
    }));
    
    //raw parameters
    const params :Ref<string[]> = ref(extractParams(circuitconfig.value.circuits.filter(c=>c.selected)[0].nodes));

    watch(circuitconfig.value.circuits.filter(c=>c.selected)[0], ()=>{
        if(fs.value){
            const files = fs.value.files;
            fs.value.keys().forEach(key=>{
                files[key].fitting_result.isDone = false;
            });
        }
        params.value = extractParams(circuitconfig.value.circuits.filter(c=>c.selected)[0].nodes);
    });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", null, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(params.value, (param, index) => {
            return (_openBlock(), _createElementBlock("th", { key: index }, _toDisplayString(param), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_unref(results)?.length == 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
              _createElementVNode("td", {
                colspan: 3+params.value.length
              }, " No Items ", 8, _hoisted_6)
            ]))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(results), (result) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: result.id
              }, [
                _createElementVNode("td", null, [
                  (fs.value?.files[result.id].under_fitting)
                    ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
                    : _createCommentVNode("", true),
                  (fs.value?.files[result.id].fitting_result.isDone)
                    ? (_openBlock(), _createBlock(MiniCheckMark, { key: 1 }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, _toDisplayString(result.name), 1),
                _createElementVNode("td", null, [
                  (fs.value?.files[result.id].fitting_result.isDone)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString((fs.value?.files[result.id].fitting_result.fit === -1)?"-":fs.value?.files[result.id].fitting_result.fit), 1))
                    : _createCommentVNode("", true)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result.params, (kv) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: kv[0]
                  }, _toDisplayString(kv[1]), 1))
                }), 128))
              ]))
            }), 128))
      ])
    ])
  ]))
}
}

})